/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {freePlayGuideStepEnum} from '~/pages/game/LuckySlot/enum'
import {InitialStateType} from './interface'

export enum BetResultStatusEnum { // 下注结果
  notEnough = 2,
  success = 1,
}

export const transOpenBoxData = (open_boxs = {}) => {
  const ret = []
  for (let i = 0; i < 6; i++) {
    if (open_boxs?.hasOwnProperty(i.toString())) {
      ret.push({
        isAuto: false,
        id: i,
        odd: open_boxs[i.toString()],
        notOpen: false,
      })
    } else {
      ret.push({
        id: i,
        notOpen: true,
      })
    }
  }
  return ret
}

export const lucky_slot_bet = createAsyncThunk(
  'lucky_slot_bet',
  async (arg: {room_id: number}, store: any) => {
    const {betAreaSelected, isFreeSpin, radioSelected} =
      store.getState().GameLuckySlot.base
    const {from, scene} = store.getState().env.otherInfo
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/lucky_slot_bet',
      {
        ...deviceinfo,
        ...arg,
        is_free_spin: isFreeSpin,
        line_bet_coin: betAreaSelected.bet,
        bet_lines: betAreaSelected.line,
        is_auto_mod: radioSelected.isAuto,
        is_quick_mod: radioSelected.isQuick,
        source: from?.toString(),
        from: scene || '',
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_slot_homepage = createAsyncThunk(
  'get_slot_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/lucky_slot_homepage',
      {
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)
export const luckyslot_newer_fplay_main = createAsyncThunk(
  'luckyslot_newer_fplay_main',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/luckyslot_newer_fplay_main',
      {
        ...deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

const initialState: InitialStateType = {
  roundInfo: {
    shakeAwardsAmising: false,
    specail_elem_match_lines: null,
  },
  base: {
    stopShaking: false,
    resultAmis: false,
    initMyCoin: false,
    playing: true,
    loading: true,
    betAreaSelected: {
      line: 0,
      bet: 0,
      showLine: false,
    },
    radioSelected: {
      isAuto: false,
      isQuick: false,
    },
    showGuide: false,
    isFreeSpin: false,
    isJackpotReward: false,
  },
  home: {},
  webMessage: {},
  kingInfo: {},
  freePlay: {
    freePlayGuideStep: freePlayGuideStepEnum.none,
  },
}

export const luckySlotSlice = createSlice({
  name: 'luckySlot',
  initialState,
  reducers: {
    updateTest: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...action.payload,
        },
      })
    },
    updateKingInfo: (state, action: PayloadAction<any>) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    },
    updatePlaying: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          playing: action.payload,
        },
      })
    },
    updateResultAmis: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          resultAmis: action.payload,
        },
      })
    },
    updateWebMessage: (state, action: PayloadAction<any>) => {
      const {webMessage} = state
      Object.assign(state, {
        webMessage: {
          ...webMessage,
          ...action.payload,
        },
      })
    },
    updateBetAreaSelected: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          betAreaSelected: {
            ...base.betAreaSelected,
            ...action.payload,
          },
        },
      })
    },
    updateRadioSelected: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          radioSelected: {
            ...base.radioSelected,
            ...action.payload,
          },
        },
      })
    },
    updateBonusGame: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          bonus_game: {
            ...roundInfo.bonus_game,
            ...action.payload,
          },
        },
      })
    },
    updateFreePlay: (state, action: PayloadAction<any>) => {
      const {freePlay} = state
      Object.assign(state, {
        freePlay: {
          ...freePlay,
          ...action.payload,
        },
      })
    },
    updateStageTask: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          stage_task: action.payload,
        },
      })
    },
    updateMyCoins: (state, action: PayloadAction<number>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          my_coins: action.payload,
          my_coins_display: action.payload,
        },
      })
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          loading: action.payload,
        },
      })
    },
    updateStopShaking: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          stopShaking: action.payload,
        },
      })
    },
    updateShakeAwardsAmising: (state, action: PayloadAction<boolean>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          shakeAwardsAmising: action.payload,
        },
      })
    },
    updateFreeSpin: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isFreeSpin: action.payload,
        },
      })
    },
    updateIsJackpotReward: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isJackpotReward: action.payload,
        },
      })
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showGuide: action.payload,
        },
      })
    },
    updateInitMyCoin: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          initMyCoin: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(luckyslot_newer_fplay_main.fulfilled, (state, action) => {
      Object.assign(state, {
        freePlay: {
          ...state.freePlay,
          ...action.payload,
        },
      })
    })
    builder.addCase(get_slot_homepage.fulfilled, (state, action) => {
      const {open_boxs = {}} = action.payload.bonus_game
      const {slot_king, ...rest} = action.payload
      Object.assign(state, {
        roundInfo: {
          stage_task: rest.stage_task,
          bonus_game: {
            ...rest.bonus_game,
            open_boxs: transOpenBoxData(open_boxs),
          },
          free_spin: rest.free_spin,
          my_coins: rest.my_coins,
          my_coins_display: rest.my_coins_display,
          result: {
            prev: rest.init_broad,
            cur: rest.init_broad,
          },
        },
        home: {
          ...rest,
          bonus_game: {
            ...rest.bonus_game,
            open_boxs: transOpenBoxData(open_boxs),
          },
        },
        base: {
          ...state.base,
          isFreeSpin: rest.free_spin?.left_num > 0,
        },
        webMessage: {
          ...state.webMessage,
          jackpot_pool: rest.jackpot_pool,
          h5_dmks: rest.h5_dmks,
        },
        kingInfo: {
          ...state.kingInfo,
          ...slot_king,
        },
      })
    })
    builder.addCase(lucky_slot_bet.fulfilled, (state, action) => {
      const {open_boxs = {}} = action.payload.bonus_game
      const {slot_king, ...rest} = action.payload
      const data =
        rest.status === BetResultStatusEnum.success
          ? {
              roundInfo: {
                ...rest,
                result: {
                  prev: state.roundInfo.result.cur,
                  cur: rest.result_broad,
                },
                bonus_game: {
                  ...rest.bonus_game,
                  open_boxs: transOpenBoxData(open_boxs),
                },
                shakeAwardsAmising: rest.status === BetResultStatusEnum.success,
              },
              webMessage: {
                ...state.webMessage,
                jackpot_pool: rest.jackpot_pool,
              },
              base: {
                ...state.base,
                isJackpotReward: !!rest.jackpot_reward,
              },
              kingInfo: {
                ...state.kingInfo,
                ...slot_king,
              },
            }
          : {
              roundInfo: {
                ...state.roundInfo,
                shakeAwardsAmising: rest.status === BetResultStatusEnum.success,
              },
            }
      Object.assign(state, data)
    })
    builder.addCase(lucky_slot_bet.rejected, (state, action) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          radioSelected: {
            ...base.radioSelected,
            isAuto: false,
          },
        },
      })
    })
  },
})
export default luckySlotSlice.reducer
export const luckySlotActions = luckySlotSlice.actions
